import * as StatusComparators from 'calling-integration-sdk-support/async-data/operators/statusComparators';
import { CallWidgetStates } from 'calling-internal-common/widget-status/constants/CallWidgetStates';
import { useUserInfo } from 'calling-ui-library/user-info/context/UserInfoContext';
import { capabilities } from 'navigation-components/capabilities';
import { useComponentState, useInvokeCapability } from 'navigation-components/consumer/hooks';
import { useEffect, useMemo } from 'react';
import { NavMarker } from 'react-rhumb';
import { useSelectedProviderContext } from 'calling-remote-common/context/SelectedProviderContext';
import { LazyThirdPartyCallingRemote } from './ThirdPartyCallingRemote';
import { useThirdPartyWidgetDetailsContext } from 'calling-remote-common/context/ThirdPartyWidgetDetailsContext';
import { useOwnerId } from '../hooks/useOwnerId';
import { useUpdateThirdPartyCallIcon } from '../hooks/useUpdateThirdPartyCallIcon';
import { useTaskQueue } from '../hooks/useTaskQueue';
import { useThirdPartyGates } from '../hooks/useThirdPartyGates';
import ThirdPartyEventHandlers from './ThirdPartyEventHandlers';
import { useOpenCloseRemote } from '../hooks/useOpenCloseRemote';
import { OpenWidgetDataContextProvider } from 'calling-integration-sdk-support/viewport/contexts/OpenWidgetDataContext';
import { useCallingSettingsFetch } from 'calling-ui-library/calling-remote-redesign/hooks/useCallingSettingsFetch';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function _ThirdPartyCall() {
  const {
    portalId,
    userId
  } = useUserInfo();
  const {
    isOpen
  } = useComponentState();
  useCallingSettingsFetch({
    shouldFetchData: isOpen
  });
  const {
    selectedCallProviderData,
    selectedCallProviderStatus,
    isThirdPartyProviderSelected,
    setShowProviderMenu
  } = useSelectedProviderContext();
  const {
    isUngatedForExtensionsInboundCalling
  } = useThirdPartyGates();
  const [context] = useThirdPartyWidgetDetailsContext();
  const {
    thirdPartyCallStatus
  } = context;
  const {
    openRemote,
    isPopoverMinimized,
    hasThirdPartyOpened
  } = useOpenCloseRemote();
  useEffect(() => {
    if (thirdPartyCallStatus === CallWidgetStates.INCOMING_INBOUND_CALL) {
      setShowProviderMenu(false);
      if (isPopoverMinimized) openRemote();
    }
  }, [setShowProviderMenu, thirdPartyCallStatus, isPopoverMinimized, openRemote]);
  const updateThirdPartyCallStatus = useInvokeCapability(capabilities.UPDATE_THIRD_PARTY_CALL_STATUS_CAP);
  const isLoading = useMemo(() => {
    return [CallWidgetStates.UNINITIALIZED, CallWidgetStates.LOADING].includes(thirdPartyCallStatus);
  }, [thirdPartyCallStatus]);
  const renderThirdPartyCallIcon = useMemo(() => {
    return isUngatedForExtensionsInboundCalling && StatusComparators.isFailed(selectedCallProviderStatus) || isThirdPartyProviderSelected;
  }, [isThirdPartyProviderSelected, isUngatedForExtensionsInboundCalling, selectedCallProviderStatus]);
  useEffect(() => {
    updateThirdPartyCallStatus({
      renderThirdPartyCallIcon
    });
  }, [renderThirdPartyCallIcon, updateThirdPartyCallStatus]);
  const usesCallingWindow = !!selectedCallProviderData.usesCallingWindow;
  useUpdateThirdPartyCallIcon({
    isLoading,
    supportsCallingWindow: usesCallingWindow,
    hasThirdPartyOpened
  });
  const {
    ownerId
  } = useOwnerId({
    userId
  });
  useTaskQueue({
    ownerId,
    usesCallingWindow
  });
  const shouldPreloadCallingRemote = useMemo(() => {
    return !usesCallingWindow || hasThirdPartyOpened;
  }, [usesCallingWindow, hasThirdPartyOpened]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "INDEX_LOAD"
    }), /*#__PURE__*/_jsx(ThirdPartyEventHandlers, {}), shouldPreloadCallingRemote && /*#__PURE__*/_jsx(LazyThirdPartyCallingRemote, {
      isLoading: isLoading,
      portalId: portalId,
      userId: userId,
      ownerId: ownerId
    })]
  });
}
export function ThirdPartyCall() {
  return /*#__PURE__*/_jsx(OpenWidgetDataContextProvider, {
    children: /*#__PURE__*/_jsx(_ThirdPartyCall, {})
  });
}